import { ref as B, onBeforeUnmount as v, watch as b, resolveComponent as c, openBlock as r, createElementBlock as w, normalizeClass as a, createElementVNode as n, renderSlot as s, createBlock as m, withCtx as u, withModifiers as h, createCommentVNode as p, createVNode as H, createTextVNode as _ } from "vue";
import { targetContainsClickEvent as M } from "./design-system.es140.js";
/* empty css                    */
import T from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import z from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
import S from "./design-system.es17.js";
import I from "./design-system.es18.js";
import k from "./design-system.es141.js";
import x from "./design-system.es142.js";
/* empty css                    */
const E = {
  name: "DsModal",
  components: {
    IconButton: z,
    ModalHeader: S,
    ModalHeaderTitle: I
  },
  props: {
    /**
     * Controls the open state of the modal.
     */
    isOpen: Boolean,
    /**
     * Determines if this is a dialog modal or not
     */
    dialog: Boolean,
    /**
     * Is the close visible
     */
    showClose: Boolean,
    /**
     * Is the back button visible
     */
    showBack: Boolean,
    /**
     * Center the modal vertically
     */
    center: Boolean,
    /**
     * The title of the modal
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * A string below the title
     */
    subTitle: {
      type: String,
      default: ""
    },
    /**
     * Determines the size of the modal
     */
    size: {
      type: String,
      default: null,
      options: ["xs", "sm", "med", "lg", "xl", "fluid", "fullscreen"]
    },
    /**
     * Use sticky header on desktop as well as mobile
     */
    stickyDesktopHeader: Boolean
  },
  emits: [
    "back",
    "close"
  ],
  setup(t) {
    const { open: l, close: e } = x(), i = B(!1);
    return v(() => {
      e();
    }), b(() => t.isOpen, (d) => {
      i.value = d, d ? l() : e();
    }, { immediate: !0 }), {
      isOpenInternal: i
    };
  },
  computed: {
    hasHeader() {
      return !!this.title || this.showBack || this.showClose;
    },
    computedSize() {
      return this.size ? this.size : this.dialog ? "xs" : "med";
    },
    isFullscreen() {
      return this.computedSize === "fullscreen";
    }
  },
  methods: {
    tryBack() {
      this.$emit("back");
    },
    tryClose() {
      this.$emit("close");
    },
    overlayClick(t) {
      !this.dialog && !M(t, this.$refs.modalContentWrapper) && (!k() || document.documentElement.clientWidth - t.pageX > k()) && this.tryClose();
    }
  }
}, N = { class: "modal-body-inner" };
function O(t, l, e, i, d, o) {
  const f = c("IconButton"), y = c("ModalHeaderTitle"), C = c("ModalHeader");
  return r(), w("div", {
    class: a(["modal-overlay", { dialog: e.dialog, open: i.isOpenInternal, fullscreen: o.isFullscreen }]),
    onMousedown: l[0] || (l[0] = (...g) => o.overlayClick && o.overlayClick(...g))
  }, [
    n("div", {
      class: a(["modal-dialog", [o.computedSize, { dialog: e.dialog, center: e.center }]])
    }, [
      n("div", {
        ref: "modalContentWrapper",
        class: a(["modal-content-wrapper", { dialog: e.dialog }])
      }, [
        s(t.$slots, "heading", {}, () => [
          o.hasHeader ? (r(), m(C, {
            key: 0,
            sticky: e.stickyDesktopHeader,
            fullscreen: o.isFullscreen
          }, {
            leading: u(() => [
              e.showBack ? (r(), m(f, {
                key: 0,
                id: "back",
                name: "arrow-left",
                class: "navigation-button",
                onClick: h(o.tryBack, ["stop"])
              }, null, 8, ["onClick"])) : e.showClose ? (r(), m(f, {
                key: 1,
                id: "close",
                name: "x",
                class: "navigation-button",
                onClick: h(o.tryClose, ["stop"])
              }, null, 8, ["onClick"])) : p("", !0)
            ]),
            title: u(() => [
              s(t.$slots, "title", {}, () => [
                H(y, {
                  title: e.title,
                  subtitle: e.subTitle
                }, null, 8, ["title", "subtitle"])
              ], !0)
            ]),
            trailing: u(() => [
              s(t.$slots, "header", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["sticky", "fullscreen"])) : p("", !0)
        ], !0),
        l[3] || (l[3] = _()),
        n("div", {
          class: a(["modal-body", { "has-header": o.hasHeader }])
        }, [
          n("div", N, [
            s(t.$slots, "default", {}, void 0, !0)
          ])
        ], 2)
      ], 2)
    ], 2)
  ], 34);
}
const Z = /* @__PURE__ */ T(E, [["render", O], ["__scopeId", "data-v-68c1b224"]]);
export {
  Z as default
};
//# sourceMappingURL=design-system.es16.js.map
